import React, { useEffect, useMemo } from 'react';

import {
  APIOrderCustomFieldValue,
  APIOrderFieldDefinitionModel,
} from '@cd3p/core/types/api';
import { textField } from '@cd3p/core/utils/fields';
import { filterFieldsByCompanyId } from '@cd3p/core/utils/orderFieldsSchema';
import { FormField } from 'components';
import { FieldError, useFormContext } from 'react-hook-form';

type OrderCustomFieldsProps = {
  isDisabled?: boolean;
  orderFields?: APIOrderFieldDefinitionModel[] | null;
  companyId?: string;
  orderFieldValues?: APIOrderCustomFieldValue[];
};

export const OrderCustomFieldsEdit: React.FC<OrderCustomFieldsProps> = ({
  isDisabled = false,
  orderFields,
  companyId,
  orderFieldValues,
}) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (orderFieldValues) {
      orderFieldValues.forEach(field => {
        setValue(field.name, field.value);
      });
    }
  }, [orderFieldValues, setValue]);

  const filteredFields = useMemo(() => {
    return filterFieldsByCompanyId(orderFields, companyId);
  }, [orderFields, companyId]);

  if (!filteredFields) {
    return null;
  }

  return (
    <>
      {filteredFields?.map(field => (
        <FormField
          key={field.name}
          fieldName={field.name}
          fieldError={errors[field.name] as FieldError}
          label={field.label}
          placeholder={field.placeholder}
          isRequired={false}
          control={control}
          maxLength={textField.maxLength}
          inputProps={{
            maxLength: textField.maxLength,
          }}
          isDisabled={isDisabled}
          showError={false}
          multiline
        />
      ))}
    </>
  );
};
